import React from 'react';

const GoogleUseAgreement = () => {

    return (
        <>
            <div className='p-3'>
                <h2 className='fs-4'>Google API 이용자 개인정보 처리 방침</h2>
                <div className='agree-wrap '>
                    <div className="agree-box full-height" >
                        <div className="terms-wrap">
                            <div className="sec">
                                <p>본 서비스는 이용자가 선택적으로 사용하는 관심 고객 정보 수집 기능(Google Form 자동 생성 및 연동 기능) 제공을 위해 Google OAuth 인증 및 Google API를 이용합니다.</p>
                                <p>회사는 Google API Services User Data Policy 및 Limited Use 요구사항을 준수하여 Google 사용자 데이터를 처리합니다.</p>
                            </div>

                            <div className="sec">
                                <h3>1. 수집 및 저장하는 정보</h3>
                                <p>회사는 Google 계정 연동 과정에서 다음 정보를 수집하여 서비스 제공을 위해 저장합니다.</p>
                                <ol>
                                    <li>(1) Google 계정 이메일 주소: 서비스 내 사용자 식별 및 계정 연동 관리</li>
                                    <li>(2) Google Refresh Token: 이용자를 대신하여 Google Form 생성 기능을 제공하기 위한 Google API 인증 권한 유지</li>
                                    <li>(3) Google Form ID: 이용자를 대신하여 생성된 Google Form 식별</li>
                                    <li>(4) Watch ID: 생성된 Google Form의 응답 상태 변경 감지 및 서비스 연동</li>
                                </ol>
                            </div>

                            <div className="sec">
                                <h3>2. 이용 목적</h3>
                                <p>수집된 정보는 다음 목적에 한하여 사용됩니다.</p>
                                <ol>
                                    <li>(1) Google 계정 인증 및 서비스 계정 연동 유지</li>
                                    <li>(2) 이용자를 대신한 Google Form 생성</li>
                                    <li>(3) Google Form 응답 변경 감지 및 연동 기능 제공</li>
                                    <li>(4) 생성된 Google Form 관리 기능 제공</li>
                                </ol>
                            </div>

                            <div className="sec">
                                <h3>3. 데이터의 전송 및 제3자 제공</h3>
                                <ol>
                                    <li>(1) 서비스 기능 제공 과정에서 이용자의 요청에 따라 필요한 정보가 Google 서비스(Google LLC)로 전송될 수 있습니다.</li>
                                    <li>(2) 회사는 Google LLC 외 어떠한 제3자에게도 Google 사용자 데이터를 판매, 공유, 이전 또는 공개하지 않습니다.</li>
                                </ol>
                            </div>

                            <div className="sec">
                                <h3>4. 보관 및 이용 기간</h3>
                                <ol>
                                    <li>(1) Google 사용자 데이터는 서비스 계정 식별 및 Google Form 연동 기능 제공을 위해 보관됩니다.</li>
                                    <li>(2) 이용자가 Google 계정 설정에서 본 서비스에 대한 접근 권한을 철회할 경우, 저장된 인증 토큰은 더 이상 유효하지 않으며 Google API 기반 기능(폼 생성 등)은 사용할 수 없습니다.</li>
                                    <li>(3) 회사는 회원 탈퇴 시 관련 Google 사용자 데이터를 지체 없이 삭제합니다.</li>
                                </ol>
                            </div>

                            <div className="sec">
                                <h3>5. 데이터 보호 및 보안 조치</h3>
                                <p>회사는 사용자의 민감한 데이터(Refresh Token 등)를 보호하기 위해 다음과 같은 보안 조치를 시행하고 있습니다.</p>
                                <ol>
                                    <li>(1) 기술적 보호: 수집된 모든 구글 인증 토큰은 데이터베이스 저장 시 암호화 알고리즘(AES-256)을 사용하여 암호화되어 저장됩니다.</li>
                                    <li>(2) 전송 보안: 모든 데이터 전송은 HTTPS(TLS/SSL) 프로토콜을 통해 암호화되어 전송됩니다.</li>
                                    <li>(3) 접근 제어: 구글 사용자 데이터가 저장된 서버는 인가된 최소한의 인원만이 접근할 수 있도록 엄격한 접근 권한 관리 정책을 적용하고 있습니다.</li>
                                </ol>
                            </div>

                            <div className="sec">
                                <h3>6. 사용자의 권한 및 통제</h3>
                                <ol>
                                    <li>(1) 이용자는 언제든지 Google 계정 설정의 [보안] &gt; [내 계정에 액세스할 수 있는 제3자 앱] 메뉴에서 본 서비스에 부여된 접근 권한을 철회할 수 있습니다.</li>
                                    <li>(2) 접근 권한 철회 시 Google API 기능 이용이 제한될 수 있습니다.</li>
                                </ol>
                            </div>

                            <div className="sec">
                                <h3>7. 제한적 사용 및 정책 준수</h3>
                                <ol>
                                    <li>(1) 회사는 Google 사용자 데이터를 서비스 기능 제공 목적 범위 내에서만 사용하며, 제3자 제공 목적으로 활용하지 않습니다.</li>
                                    <li>(2) 본 서비스는 Google API Services User Data Policy의 Limited Use 요구사항을 준수합니다.</li>
                                </ol>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </>
    );
};

export default GoogleUseAgreement;

